import React, { StatelessComponent } from 'react';
import { SEPARATOR } from '../utils/constants';
import './_styles.scss';

export const Separator: StatelessComponent = () => {
    return <div className={SEPARATOR} />;
};



// WEBPACK FOOTER //
// ./src/packages/components/lib/Separator/index.tsx